import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function Testimonials() {
  return <section className="py-16 md:py-24 bg-[#0a0a0a]" data-id="element-184">
      <div className="max-w-6xl mx-auto px-4" data-id="element-185">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8" data-id="element-186">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#111] p-5 md:p-8 rounded-2xl border border-white/5 relative" data-id="element-187">
            <Quote className="absolute top-4 right-4 md:top-6 md:right-6 text-white/10" size={36} data-id="element-188" />
            <p className="text-sm md:text-lg text-gray-300 italic mb-4 md:mb-6 relative z-10" data-id="element-189">
              "Después de aplicar la rutina AM/PM noté que mi energía ya no se
              desplomaba por las tardes. El cambio fue notable."
            </p>
            <div className="flex items-center gap-3 md:gap-4" data-id="element-190">
              <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-cyan-900/50 flex items-center justify-center text-cyan-400 font-bold text-sm" data-id="element-191">
                LG
              </div>
              <span className="text-white font-semibold text-sm md:text-base" data-id="element-192">
                Laura G.
              </span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#111] p-5 md:p-8 rounded-2xl border border-white/5 relative" data-id="element-193">
            <Quote className="absolute top-4 right-4 md:top-6 md:right-6 text-white/10" size={36} data-id="element-194" />
            <p className="text-sm md:text-lg text-gray-300 italic mb-4 md:mb-6 relative z-10" data-id="element-195">
              "Llevaba meses con niebla mental. Siguiendo el plan de luz y sueño
              del primer PDF, volví a sentirme con claridad."
            </p>
            <div className="flex items-center gap-3 md:gap-4" data-id="element-196">
              <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-cyan-900/50 flex items-center justify-center text-cyan-400 font-bold text-sm" data-id="element-197">
                CM
              </div>
              <span className="text-white font-semibold text-sm md:text-base" data-id="element-198">
                Carlos M.
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}